/* loaded by smart-asset */
export default require("./first_page-24px~twunSRbC.svg")